import Cookies from 'js-cookie';

// Get user information from cookies
export const getUserInfo = () => {
  const user_email = Cookies.get('user_email');
  const user_role = Cookies.get('user_role');
  const user_permissions = Cookies.get('user_permissions');
  
  return {
    email: user_email,
    role: user_role,
    permissions: user_permissions ? JSON.parse(user_permissions) : []
  };
};

// Check if user has a specific permission
export const hasPermission = (permission) => {
  const { permissions } = getUserInfo();
  return permissions.includes(permission);
};

// Check if user has any of the specified permissions
export const hasAnyPermission = (permissionList) => {
  const { permissions } = getUserInfo();
  return permissionList.some(permission => permissions.includes(permission));
};

// Check if user has all of the specified permissions
export const hasAllPermissions = (permissionList) => {
  const { permissions } = getUserInfo();
  return permissionList.every(permission => permissions.includes(permission));
};

// Check if user has a specific role
export const hasRole = (role) => {
  const { role: userRole } = getUserInfo();
  return userRole === role;
};

// Check if user has any of the specified roles
export const hasAnyRole = (roleList) => {
  const { role: userRole } = getUserInfo();
  return roleList.includes(userRole);
};

// Check if user is admin
export const isAdmin = () => {
  return hasRole('admin');
};

// Check if user is manager or admin
export const isManagerOrAdmin = () => {
  return hasAnyRole(['admin', 'manager']);
};
// Check if user is manager or admin
export const isDeveloperOrAdmin = () => {
  return hasAnyRole(['admin', 'developer']);
};
// Get user display name (email or role)
export const getUserDisplayName = () => {
  const { email, role } = getUserInfo();
  return email || role || 'User';
};
